import { analytics, performance } from "../firebase.ts";
import { trace, PerformanceTrace } from "firebase/performance";
import { logEvent, setUserProperties } from "firebase/analytics";

import { Bookmarks } from "../managers/Bookmarks.ts";
import { SwHeader } from "./sw-header/sw-header.ts";
import { SwMain } from "./sw-main/sw-main.ts";
import { SwFooter } from "./sw-footer/sw-footer.ts";
import { SwBanner } from "./sw-header/sw-banner/sw-banner.ts";
import { SwAlert } from "./sw-footer/sw-alert/sw-alert.ts";
import Strings from "../models/Strings.json";
import { LANGUAGE } from "./global.ts";
import { version } from "../../package.json";
import { MINOR_VERSION } from "../sw3.ts";

const strings: any = Strings;

export class SwBedok extends HTMLBodyElement {
    private componentTrace: PerformanceTrace;
    private bookmarks = new Bookmarks();

    private drawer: HTMLHtmlElement;
    private header: SwHeader;
    private main: SwMain;
    private footer: SwFooter;
    private banner: SwBanner;
    private alert: SwAlert;

    private observer: MutationObserver;
    private targetNode: HTMLElement;

    constructor() {
        super();
        this.componentTrace = trace(performance, "component");
        this.componentTrace.putAttribute("view", "sw-bedok");
        this.componentTrace.start();

        this.drawer = this.querySelector("#sw-menu-hide")!;
        this.header = this.querySelector("sw-header")!;
        this.main = this.querySelector("sw-main")!;
        this.footer = this.querySelector("sw-footer")!;
        this.banner = this.querySelector("sw-banner")!;
        this.alert = this.querySelector("sw-alert")!;

        this.targetNode = document.documentElement;
        this.observer = new MutationObserver(this.handleMutations.bind(this));
    }

    connectedCallback() {
        this.updateLanguage();
        this.updateView();
        this.addListeners();
        this.startObserving();

        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.addEventListener("message", (event) => {
                //console.log(event.data);
                if (event.data.action === "deeplink") {
                    const { url } = event.data;
                    window.location.href = url;
                }
            });
        }

        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }

    private updateLanguage() {
        // const language = localStorage.getItem("language");
        // if (language === null) {
        //     localStorage.setItem("language", "khmer");
        // }

        const major = document.querySelector('meta[name="major"]')!;
        major.setAttribute("content", version.toString());

        const minor = document.querySelector('meta[name="minor"]')!;
        minor.setAttribute("content", MINOR_VERSION);

        const description = document.querySelector('meta[name="description"]')!;
        description.setAttribute("content", strings.hero2[LANGUAGE]);

        document.title = strings.title2[LANGUAGE];
        document.documentElement.lang = strings.language[LANGUAGE];
    }

    private addListeners() {
        window.addEventListener("popstate", this.updateView.bind(this));

        this.addEventListener("sw-banner", (event: Event) => {
            const customEvent = event as CustomEvent<{
                info: string;
                reload?: boolean;
            }>;
            this.banner.showBanner(
                customEvent.detail.info,
                customEvent.detail.reload || false
            );
            logEvent(analytics, "banner", {
                info: customEvent.detail.info,
                reload: customEvent.detail.reload || false
            });
        });

        this.addEventListener("sw-alert", (event: Event) => {
            const customEvent = event as CustomEvent<{
                info: string;
                reload?: boolean;
            }>;
            this.alert.showBanner(
                customEvent.detail.info,
                customEvent.detail.reload || false
            );
            logEvent(analytics, "alert", {
                info: customEvent.detail.info,
                reload: customEvent.detail.reload || false
            });
        });
    }

    private async updateView() {
        const paths = window.location.hash.split("/");

        if (paths[2] !== undefined && paths[4] !== undefined) {
            const book = parseInt(paths[2]);
            const page = parseInt(paths[4]);
            this.drawer.click();
            this.main.pageTo(book, page);
            // window.scrollTo({
            //     top: 0,
            //     behavior: "smooth"
            // });
        } else if (paths[2] !== undefined) {
            const book = parseInt(paths[2]);
            const page = (await this.bookmarks.get(book)) || 0;
            //window.location.hash = `/book/${book}/page/${page}`;
            window.location.setHash(book, page);
        } else {
            const bookmark = await this.bookmarks.getRecent();
            if (window.location.hash === "#bookmark") {
                if (bookmark)
                    window.location.setHash(bookmark.book, bookmark.page);
                else window.location.setHash(1, 0);
                //window.location.hash = `/book/${bookmark.book}/page/${bookmark.page}`;
            } else {
                this.drawer.click();
                this.main.homeTo(window.location.hash);
            }
        }

        logEvent(analytics, "hash", { hash: window.location.hash });
        //this.heartbank.alertAdmin("page/visit");
    }

    private startObserving(): void {
        this.observer.observe(this.targetNode, {
            attributes: true,
            attributeFilter: ["class"]
        });
        //console.log("Started observing for class changes.");
    }

    private stopObserving(): void {
        this.observer.disconnect();
        //console.warn("Stopped observing for class changes.");
    }

    private handleMutations(mutationsList: MutationRecord[]): void {
        for (const mutation of mutationsList) {
            if (
                mutation.type === "attributes" &&
                mutation.attributeName === "class"
            ) {
                const paths = window.location.hash.split("/");
                if (paths[2] !== undefined && paths[4] !== undefined) {
                    const book = parseInt(paths[2]);
                    const page = parseInt(paths[4]);
                    this.main.pageTo(book, page);
                }
            }
        }
    }
}
